import React from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { IconPlanPro, IconPlanPremium, IconLocked, IconSuccess, IconEmail, IconPhone, } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
import { Button } from 'autenti-components';
const Wrapper = styled.div `
  display: flex;
  padding: 24px;
  border-radius: 8px;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
const LeftSide = styled.div `
  flex-basis: 50%;

  @media (max-width: 900px) {
    flex-basis: 100%;
    margin: 0;
    padding: 20px;
  }
  @media (min-width: 800px) and (max-width: 899px) {
    padding-right: 70px;
  }
  @media (min-width: 901px) {
    margin-right: 16px;
  }
`;
const MainHeader = styled.p `
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
`;
const Description = styled.p `
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
`;
const ListIcon = styled.div `
  align-items: flex-start;
  display: flex;
  margin-bottom: 6px;
`;
const ItemTextWrapper = styled.div `
  font-size: 14px;
`;
const IconWrapper = styled.div `
  svg {
    height: 16px;
    margin: 4px 10px 0 0;
    width: 16px;
  }
`;
const MainIconWrapper = styled.div `
  svg {
    height: 40px;
    width: 40px;
  }
`;
const ImageWrapper = styled.div `
  flex-basis: 50%;
  @media (max-width: 900px) {
    display: none;
  }

  ${({ imageName }) => imageName === 'documentAccessNoUsers' &&
    `
    margin: 29px;
    margin-left: 60px;
    img {
    height: 230px;
    width: 230px;
    }
  `}
`;
const ContactDetails = styled.div `
  display: flex;
  flex-direction: column;
  .contact {
    display: flex;
    &:not(:first-child) {
      margin-top: 0.5rem;
    }
  }
  a {
    color: #1c92dd;
    margin-left: 0.5rem;
    font-size: 14px;
  }
  @media (min-width: 480px) {
    flex-direction: row;
    .contact {
      &:not(:first-child) {
        margin-top: 0;
        margin-left: 35px;
      }
    }
  }
`;
const ButtonWrapper = styled.div `
  margin-top: 24px;
`;
const getImageSrc = (image, language) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    switch (image) {
        case 'apiWindow':
            return (_a = require(`./Images/${language}/APIandIntegrationsW.svg`)) === null || _a === void 0 ? void 0 : _a.default;
        case 'boardWindow':
            return (_b = require(`./Images/${language}/BoardW.svg`)) === null || _b === void 0 ? void 0 : _b.default;
        case 'documentAccessWindow':
            return (_c = require(`./Images/${language}/DocumentAccessW.svg`)) === null || _c === void 0 ? void 0 : _c.default;
        case 'documentAccessNoUsers':
            return (_d = require(`./Images/${language}/DocumentAccessNoUsers.svg`)) === null || _d === void 0 ? void 0 : _d.default;
        case 'documentWithDrawnPopUp':
            return (_e = require(`./Images/${language}/DocumentWithdrawnPU.svg`)) === null || _e === void 0 ? void 0 : _e.default;
        case 'messageTemplatesWindow':
            return (_f = require(`./Images/${language}/MessageTemplatesW.svg`)) === null || _f === void 0 ? void 0 : _f.default;
        case 'organizationSso':
            return (_g = require(`./Images/${language}/OrganizationSso.svg`)) === null || _g === void 0 ? void 0 : _g.default;
        case 'sharedDocuments':
            return (_h = require(`./Images/${language}/SharedDocumentsW.svg`)) === null || _h === void 0 ? void 0 : _h.default;
        case 'setSigningOrderPopup':
            return (_j = require(`./Images/${language}/SetSigningOrderPU.svg`)) === null || _j === void 0 ? void 0 : _j.default;
        case 'SsoConfiguration':
            return (_k = require(`./Images/${language}/SsoConfiguration.svg`)) === null || _k === void 0 ? void 0 : _k.default;
        case 'NoSsoConfigured':
            return (_l = require(`./Images/${language}/NoSsoConfigured.svg`)) === null || _l === void 0 ? void 0 : _l.default;
        case 'sharedLabelsWindow':
        default:
            return (_m = require(`./Images/${language}/SharedLabelsW.svg`)) === null || _m === void 0 ? void 0 : _m.default;
    }
};
const getIcon = (iconType) => {
    switch (iconType) {
        case 'PRO':
            return (React.createElement(MainIconWrapper, null,
                React.createElement(IconPlanPro, { color: '#1872E7' })));
        case 'PREMIUM':
            return (React.createElement(MainIconWrapper, null,
                React.createElement(IconPlanPremium, { color: '#00214D' })));
        case 'LOCKED':
        default:
            return (React.createElement(MainIconWrapper, null,
                React.createElement(IconLocked, { color: '#899BAD' })));
    }
};
const UpgradeAccountWindow = ({ imageName, iconType, onClick, textContent, disabled, intl, showContactDetails, }) => {
    const lang = intl.locale === 'pl' ? 'pl' : 'eng';
    const image = getImageSrc(imageName, lang);
    const icon = getIcon(iconType);
    const { header, description, list, bottomDescription, buttonText } = textContent;
    return (React.createElement(Wrapper, { className: "upgrade-account-window" },
        React.createElement(LeftSide, null,
            iconType && React.createElement(React.Fragment, null, icon),
            React.createElement(MainHeader, null, header),
            React.createElement(Description, null, description),
            list &&
                list.map((item) => (React.createElement(ListIcon, null,
                    React.createElement(IconWrapper, null,
                        React.createElement(IconSuccess, { color: '#1C92DD' })),
                    React.createElement(ItemTextWrapper, null, item)))),
            bottomDescription && React.createElement(Description, null, bottomDescription),
            showContactDetails && (React.createElement(ContactDetails, null,
                React.createElement("div", { className: "contact" },
                    React.createElement(IconEmail, { color: "#697D8E" }),
                    React.createElement("a", { href: "mailto:sales@autenti.com" }, "sales@autenti.com")),
                React.createElement("div", { className: "contact" },
                    React.createElement(IconPhone, { color: "#697D8E" }),
                    React.createElement("a", { href: "tel:+48732123336" }, "+48 732 123 336")))),
            buttonText && (React.createElement(ButtonWrapper, null,
                React.createElement(Button.Primary, { onClick: onClick, disabled: disabled }, buttonText)))),
        React.createElement(ImageWrapper, { imageName: imageName }, image && (React.createElement("img", { src: image, alt: `${imageName} ilustration`, width: "100%" })))));
};
export default injectIntl(UpgradeAccountWindow);
